/*
 * ITG: DNI/NIE cart-page field for mainland orders.
 *
 * Behaviour:
 *   - Validates the DNI or NIE format client-side (regex + control-letter
 *     checksum) on every keystroke.
 *   - When valid, saves the value to cart.attributes.itg_dni via
 *     POST /cart/update.js so the value lands in the order as
 *     Additional Details in the Shopify admin.
 *   - When invalid or empty, disables the "Proceed to Checkout" button
 *     for this instance so the customer can't advance without a valid
 *     DNI/NIE.
 *
 * DNI = 8 digits + control letter (e.g. 12345678A)
 * NIE = one of X, Y, Z + 7 digits + control letter (e.g. X1234567L)
 *
 * The control letter for both is the (numeric portion mod 23)-th letter
 * of the reference string "TRWAGMYFPDXBNJZSQVHLCKE". For NIEs, X/Y/Z
 * map to 0/1/2 before the mod is taken.
 *
 * Runs after DOMContentLoaded and re-wires every render (drawer opens,
 * ajax cart updates) via a MutationObserver so we catch newly-injected
 * field instances too.
 */
(function () {
  var CHECKSUM_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
  var DNI_RE = /^(\d{8})([A-Z])$/;
  var NIE_RE = /^([XYZ])(\d{7})([A-Z])$/;
  var NIE_PREFIX_MAP = { X: '0', Y: '1', Z: '2' };
  var DEBOUNCE_MS = 400;

  function isValidDniNie(raw) {
    if (!raw) return false;
    var v = String(raw).toUpperCase().trim();

    var m = v.match(DNI_RE);
    if (m) {
      var numeric = parseInt(m[1], 10);
      return CHECKSUM_LETTERS.charAt(numeric % 23) === m[2];
    }

    m = v.match(NIE_RE);
    if (m) {
      var digits = NIE_PREFIX_MAP[m[1]] + m[2];
      var n = parseInt(digits, 10);
      return CHECKSUM_LETTERS.charAt(n % 23) === m[3];
    }

    return false;
  }

  function saveCartAttribute(value) {
    var body = { attributes: { itg_dni: value } };
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { /* silent fail — checkout button remains locked */ });
  }

  function setState(fieldEl, state, message) {
    var input = fieldEl.querySelector('[data-itg-dni-input]');
    var msgEl = fieldEl.querySelector('[data-itg-dni-message]');
    fieldEl.setAttribute('data-itg-dni-state', state); // pending | valid | invalid | empty
    if (input) input.setAttribute('aria-invalid', state === 'invalid' ? 'true' : 'false');
    if (msgEl && message != null) msgEl.textContent = message;
  }

  function lockCheckout(fieldEl, locked) {
    var btnId = fieldEl.getAttribute('data-itg-dni-checkout');
    if (!btnId) return;
    var btn = document.getElementById(btnId);
    if (!btn) return;
    if (locked) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('data-itg-dni-locked', '1');
    } else if (btn.getAttribute('data-itg-dni-locked') === '1') {
      // Only unlock if we're the ones who locked it (don't fight cart-empty state).
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('data-itg-dni-locked');
    }
  }

  function initFieldInstance(fieldEl) {
    if (fieldEl.getAttribute('data-itg-dni-inited') === '1') return;
    fieldEl.setAttribute('data-itg-dni-inited', '1');

    var input = fieldEl.querySelector('[data-itg-dni-input]');
    if (!input) return;

    var timer = null;

    function evaluate(fromInitialLoad) {
      var raw = input.value || '';
      var trimmed = raw.toUpperCase().trim();
      // Show upper-case immediately so users see what will be saved.
      if (input.value !== trimmed && !fromInitialLoad) input.value = trimmed;

      if (!trimmed) {
        setState(fieldEl, 'empty', 'Necesario para el envío a Península (aduanas).');
        lockCheckout(fieldEl, true);
        if (!fromInitialLoad) saveCartAttribute('');
        return;
      }
      if (!isValidDniNie(trimmed)) {
        setState(fieldEl, 'invalid', 'Formato no válido. Ejemplo: 12345678A o X1234567L.');
        lockCheckout(fieldEl, true);
        return;
      }
      setState(fieldEl, 'valid', 'DNI / NIE guardado.');
      lockCheckout(fieldEl, false);
      saveCartAttribute(trimmed);
    }

    input.addEventListener('input', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { evaluate(false); }, DEBOUNCE_MS);
    });
    input.addEventListener('blur', function () {
      if (timer) clearTimeout(timer);
      evaluate(false);
    });

    // Initial state: if cart already has a valid attr, unlock. Otherwise lock.
    evaluate(true);
  }

  function scanAndInit(root) {
    var fields = (root || document).querySelectorAll('[data-itg-dni-field]');
    for (var i = 0; i < fields.length; i++) initFieldInstance(fields[i]);
  }

  // Watch for re-renders (drawer opens, ajax cart updates re-inject the HTML).
  function watchForReRenders() {
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-itg-dni-field]')) initFieldInstance(node);
          if (node.querySelectorAll) scanAndInit(node);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanAndInit(document);
      watchForReRenders();
    });
  } else {
    scanAndInit(document);
    watchForReRenders();
  }
})();
